import Box from '@mui/material/Box';
import cover from './cover.jpg';
import Typography from '@mui/material/Typography';
import { Divider } from '@mui/material';
import { Article } from '../_/components/Article';

export const Focus = () => (
    <>
        <Typography variant="h1" align={'center'} gutterBottom>
            F©US
        </Typography>
        <Typography variant="h2" align={'center'} gutterBottom>
            System rpg
        </Typography>

        <Article.Title>Focus</Article.Title>
        <Article.Body>
            Focus to gra fabularna z zasadami na tyle prostymi by nie blokowały wyobraźni, ale na tyle rozbudowanymi, żeby mieć frajdę przy rozwoju postaci.  Z tego powodu Focus  idealnie nadaje się dla osób dopiero wchodzących w świat gier RPG, jednocześnie dając duże pole do popisu dla weteranów tego gatunku i to wszystko przy jednym wspólnym stole!
        </Article.Body>

        <Article.Title>Jak grać?</Article.Title>
        <Article.Body>
            Rozgrywka w Focus polega na wspólnym tworzeniu historii. Każdy gracz wybiera sobie postać której historię będzie tworzyć a potem wspólnie z innymi graczami opisują jak ich postacie radzą sobie z przeciwnościami losu. Żeby całej opowieści nadać jakieś ramy, odpowiednio rozdzielić czas między graczami lub pomóc postaciom zabłysnąć, focus wprowadza rolę gapia.
        </Article.Body>

        <Article.Title>Postać</Article.Title>
        <Article.Body>
            Postacie to stworzone przez wyobraźnię osób grających(graczy) istoty które będą głównymi bohaterami historii.
        </Article.Body>

        <Article.Title>Gap</Article.Title>
        <Article.Body>
            Rolę gapia obejmuje jeden z graczy, nie tworzy on wtedy swojej postaci, zamiast tego jest jedynym i najważniejszym widzem przyglądającym się poczynaniom postaci graczy. To on decyduje o całym wyglądzie sceny np: jaka jest pogoda, czy w jaskini do której wchodzą postacie mieszka niedźwiedź, smok a może kryje się tam zagadkowy skarb, o tym czy sklepikarz ma dobry humor czy będzie próbował wydrzeć z bohaterów ostatnią sztukę złota. Można powiedzieć, że gap steruje całym światem, całym poza postaciami graczy.
        </Article.Body>


        <Article.Title>Ramy świata</Article.Title>
        <Article.Body>
            Tak jak napisano wcześniej to bohaterowie tworzą wydarzenia a gap świat dookoła nich, dlatego przed wspólną rozgrywką ustalcie w jakich realiach będzie dziać się Wasza historia.
        </Article.Body>

        {false && // image usage example
            <Box paddingTop={'16px'}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <img src={cover} alt="focus cover" width={'500px'} height={'500px'} />
            </Box>
        }
    </>
);
